import { render, staticRenderFns } from "./oldmanState.vue?vue&type=template&id=36fe903f&scoped=true"
import script from "./oldmanState.vue?vue&type=script&lang=js"
export * from "./oldmanState.vue?vue&type=script&lang=js"
import style0 from "./oldmanState.vue?vue&type=style&index=0&id=36fe903f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fe903f",
  null
  
)

export default component.exports